import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsCompletedProfileMocks: MicroMoments = {
  id: 'complete-profile',
  title: 'Welcome back, Rocky. Your profile is nearly completed.',
  description: 'A complete profile makes booking and travel much easier.',
  action: {
    label: 'My Profile: Personal Details',
    url: '/myprofile/personal-details'
  },
  actionId: 'complete-profile-link',
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/profile-onboard.svg',
    alt: 'Complete Profile Logo image'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
